import { useEffect, useState } from "react";
import {
  ArrowButton,
  ArrowButtonContainer,
  CarouselContainer,
  CarouselGrid,
  CarouselHeader,
  CarouselItem,
  FlechasContainer,
} from "./localStyle";
import FlechaDerecha from "./assets/FechaDerecha";
import FlechaIzquierda from "./assets/FlechaIzquierda";

const Carousel = ({
  items,
  name,
  opcDelete,
  onClick,
  title,
  minimize,
  strLabel,
}) => {
  const [blockPosition, setBlockPosition] = useState(0);
  const cantidadFilasGrid = minimize ? 2 : 5;
  const totalBlocks = Math.ceil(items.length / cantidadFilasGrid);
  //tamaño del item del carousel + el gap del grid-row / 2. dividido 2 para que pase de una columna;
  const widthICarouselItem = 1060 / 2;
  const flgEmpty = items.length <= 0;
  const blockPrevButton = blockPosition === 0 || flgEmpty;
  const blockNextButton =
    blockPosition === (totalBlocks - 2) * widthICarouselItem ||
    flgEmpty ||
    !(items.length > 4);
  const handlePrev = () => {
    const newPosition = Math.max(0, blockPosition - widthICarouselItem);
    setBlockPosition(newPosition);
  };
  const handleNext = () => {
    const newPosition = Math.min(
      (totalBlocks - 1) * widthICarouselItem,
      blockPosition + widthICarouselItem
    );
    setBlockPosition(newPosition);
  };

  useEffect(() => {
    if (!opcDelete) setBlockPosition(0);
  }, [totalBlocks]);

  useEffect(() => {
    if (opcDelete) {
      if (items.length <= 4) setBlockPosition(0);
    }
  }, [items?.length]);

  return (
    <CarouselContainer>
      <CarouselHeader>
        {minimize && (
          <span>
            {title}:{" "}
            {items.length <= 0 && (
              <span className="CarouselHeader-txtEmpty">Sin coincidencias</span>
            )}
          </span>
        )}
      </CarouselHeader>
      <div style={{ overflow: "hidden" }}>
        <CarouselGrid
          minimize={minimize}
          cantidadFilasGrid={cantidadFilasGrid}
          style={{ transform: `translateX(-${blockPosition}px)` }}
        >
          {items.map((item, index) => (
            <CarouselItem
              opcDelete={opcDelete}
              key={index}
              onClick={() => !opcDelete && onClick(item)}
            >
              {opcDelete && (
                <span onClick={() => onClick(item)} className="Carousel-Cruz">
                  X
                </span>
              )}
              {opcDelete && item.Particular ? (
                <span> {strLabel + ": " + item[name].toUpperCase()}</span>
              ) : (
                item[name].toUpperCase()
              )}
            </CarouselItem>
          ))}
        </CarouselGrid>
      </div>
      {items.length > 0 && (
        <FlechasContainer>
          {!blockPrevButton && (
            <div onClick={handlePrev}>
              <ArrowButtonContainer minimize={minimize}>
                <ArrowButton
                  opcDelete={opcDelete}
                  disabled={blockPrevButton}
                  left={22}
                >
                  <FlechaIzquierda />
                </ArrowButton>
              </ArrowButtonContainer>
            </div>
          )}
          {!blockNextButton && (
            <div onClick={handleNext}>
              <ArrowButtonContainer disabled={blockNextButton} minimize={minimize}>
                <ArrowButton
                  opcDelete={opcDelete}
                  disabled={blockNextButton}
                  right={22}
                >
                  <FlechaDerecha />
                </ArrowButton>
              </ArrowButtonContainer>
            </div>
          )}
        </FlechasContainer>
      )}
    </CarouselContainer>
  );
};

export default Carousel;
